import { type FC, Fragment, type ReactNode } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import cn from 'classnames';

import CheckIcon from '/img/icons/check.svg';

interface SelectVipBenefitProps {
  icon: () => ReactNode;
  transKey: string;
  className?: string;
  notAvailable?: boolean;
}

const SelectVipBenefit: FC<SelectVipBenefitProps> = ({
  icon,
  transKey,
  className,
  notAvailable,
}) => {
  const { t } = useTranslation();

  return (
    <div className="flex items-center h-10 pr-3 pl-2 bg-white/5 backdrop-blur-[32px] rounded-lg justify-between">
      <div
        className={cn(
          'flex items-center gap-2',
          !!notAvailable && 'opacity-30',
        )}
      >
        {icon()}
        <p
          className={cn(
            'text-sm font-normal text-white/80 leading-1.2 [&>span]:text-gold [&>span]:font-bold',
            className,
          )}
        >
          <Trans
            i18nKey={transKey}
            defaults={transKey}
            components={{ span: <span />, br: <Fragment /> }}
          />
        </p>
      </div>
      {notAvailable ? (
        <span className="font-bold text-sm uppercase">{t('soon')}</span>
      ) : (
        <img src={CheckIcon} alt="check" className="w-4 mx-1" />
      )}
    </div>
  );
};

export default SelectVipBenefit;
